import { NavLink, useLocation } from "react-router-dom";
import { ListTodo, Percent, Users, FileText, Circle } from "lucide-react";

function AdminSidebar({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (open: boolean) => void }) {
  const location = useLocation();

  const adminMenuItems = [
    { to: "/admin/orders", label: "Заказы", icon: ListTodo },
    { to: "/admin/markups", label: "Наценки", icon: Percent },
    { to: "/admin/users", label: "Пользователи", icon: Users },
    { to: "/admin/user-registration", label: "Регистрация пользователей", icon: Users },
    { to: "/admin/warehouse", label: "Склад", icon: FileText },
    { to: "/admin/tyres", label: "Шины", icon: Circle }
  ];

  const handleLinkClick = () => {
    // Закрыть меню с небольшой задержкой
    setTimeout(() => setIsOpen(false), 100);
  };

  return (
    <aside
      className={`flex w-full flex-col text-[15px] md:sticky md:top-16 md:h-body md:w-[240px] xl:w-[260px] max-md:fixed max-md:inset-0 max-md:z-40 max-md:bg-background/80 max-md:pt-16
        ${
          isOpen ? "bg-gray-100" : "max-md:backdrop-blur-md max-md:hidden"
        }`}
    >
      <div className="sticky top-16 flex flex-col gap-8 pb-10 pt-4 max-md:px-4 md:pr-3 md:pt-10">
        {/* Admin Menu Items */}
        <div className="flex-1 overflow-y-auto">
          {adminMenuItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={handleLinkClick}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-md px-4 py-2 transition-colors duration-100 [&_svg]:size-4 ${
                  isActive
                    ? "bg-gray-200 text-gray-700 font-medium"
                    : "text-gray-500 hover:bg-gray-50 hover:text-gray-600"
                } text-sm`
              }
            >
              <span className="w-4 h-4">{item.icon && <item.icon />}</span>
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </aside>
  );
}

export default AdminSidebar; 